import {scrubbar_modeWave_setupCanvas, view_wave_setupRandomPcm} from "./_player_scrubModeWave";

/**
 * called from setup_structure
 * @param {DzsAudioPlayer} selfClass
 */
export function setup_structure_scrub(selfClass) {

  return () => {

    const o = selfClass.initOptions;

    if (o.skinwave_enableSpectrum === 'on') {


      // -- spectrum ON
      scrubbar_modeWave_setupCanvas({}, selfClass);
      // -- old spectrum code
      selfClass._scrubbarbg_canvas = selfClass.cthis.find('.scrub-bg-img').eq(0);
      selfClass._scrubBgCanvasCtx = selfClass._scrubbarbg_canvas.get(0).getContext("2d");
    } else {

      if (o.skinwave_wave_mode === 'canvas') {
        if (selfClass.cthis.attr('data-pcm')) {
          scrubbar_modeWave_setupCanvas({}, selfClass);
        } else {
          view_wave_setupRandomPcm(selfClass)();
        }
      }
    }

  }

}

